import { attr } from '@ember-data/model';
import ShModel from './sh-model';

class CompanyBillingDefault extends ShModel {
  @attr('number') tier;
  @attr('number') tierVersion;
  @attr('number') finderFee;
  @attr('number') inviteeFee;
  @attr('number') delinquentFee;
  @attr('number') expenseFee;
  @attr('number') advanceFee;
  @attr('number') cancelFee;
  @attr('number') selectBaseFee;
  @attr('number') selectFee;
  @attr('json') features;
  @attr('number') invoiceNet;
}

export default CompanyBillingDefault;

